import React from 'react';
import styled from 'styled-components';
import { Heading, Text } from '../../design-system/components/Typography';
import { spacing } from '../../design-system/tokens/spacing';
import { borders } from '../../design-system/tokens/borders';
import { typography } from '../../design-system/tokens/typography';

const Section = styled.section`
  background: ${props => props.theme.colors.surface};
  border: ${borders.width.thin} solid ${props => props.theme.colors.borderLight || props.theme.colors.border};
  border-radius: ${borders.radius.lg};
  padding: ${spacing[5]} ${spacing[6]};
  box-shadow: none;
`;

const Header = styled.div`
  margin-bottom: ${spacing[4]};
`;

const Title = styled(Heading)`
  margin: 0 0 ${spacing[1]} 0 !important;
  font-size: ${typography.fontSize.section};
`;

const Subtitle = styled(Text)`
  display: block;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[4]};
`;

export interface DashboardSectionProps {
  title?: string;
  subtitle?: string;
  children: React.ReactNode;
  className?: string;
  /** Optional id for the section heading. */
  titleId?: string;
}

/**
 * Quiet dashboard surface — hairline border, no elevation or decorative patterns.
 */
export const DashboardSection: React.FC<DashboardSectionProps> = ({
  title,
  subtitle,
  children,
  className,
  titleId,
}) => (
  <Section className={className}>
    {(title || subtitle) && (
      <Header>
        {title && (
          <Title id={titleId} variant="h3" as="h2">
            {title}
          </Title>
        )}
        {subtitle && (
          <Subtitle size="sm" color="secondary">
            {subtitle}
          </Subtitle>
        )}
      </Header>
    )}
    <Body>{children}</Body>
  </Section>
);

export default DashboardSection;
